<script>
export default {
  props: {
    showAlert: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      limitTime: 1 * 60 * 1000,
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
  },
  created() {
    const timerId = setInterval(() => {
      this.limitTime -= 1000
      if (!this.$store.state.auth.sessionAlert) clearInterval(timerId)
      if (this.limitTime < 1) {
        clearInterval(timerId)
        this.logout()
      }
    }, 1000)
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/setSessionAlertStatus', false)
      localStorage.clear()
      sessionStorage.clear()
      this.$router.push({ name: 'safeHavenLogout' })
    },
    dismissAlert() {
      this.$store.dispatch('auth/setSessionAlertStatus', false)
    },
  },
}
</script>

<template>
  <v-container class="pa-0">
    <v-dialog
      v-model="showAlert"
      scrollable
      persistent
      min-width="200"
      max-width="420"
      no-click-animation
      transition="fade-transition"
      :content-class="'elevation-0' + ' ' + $style.dialogMenu"
    >
      <v-card :class="$style.dialogContainer">
        <v-card-text :class="$style.chatContainer" class="text-center">
          <div :class="$style.contentContainer" class="mb-7">
            <img
              :src="require('@assets/images/warning.png')"
              :class="$style.warning_img"
            />
            <div :class="$style.textContainer">
              <p :class="$style.alertText">
                Your session is about to expire.
              </p>
              <p :class="$style.alertText">
                Your session will be logged out in
                {{ limitTime / 1000 }} seconds.
              </p>
            </div>
          </div>
          <v-row :class="$style.buttonContainer" class="mb-1">
            <div class="px-2 py-1" :class="$style.inactiveBtn">
              <a
                class="clickable"
                :class="$style.hrRouterLinkText"
                @click="logout"
              >
                Logout
              </a>
            </div>
            <div class="px-2 py-1 ml-2" :class="$style.activeBtn">
              <a
                class="clickable"
                :class="$style.hrRouterLinkTextStrong"
                @click="dismissAlert"
              >
                Continue Session
              </a>
            </div>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.dialogMenu {
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.dialogContainer {
  background-color: #fff !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.chatContainer {
  margin-top: 30px;
}

.contentContainer {
  display: flex;
  flex-direction: row;
}
.textContainer {
  display: flex;
  flex-direction: column;
  padding-top: 3px;
  padding-left: 15px;
}

.warning_img {
  display: inline;
  width: 50px;
  height: 50px;
}

.alertText {
  margin-bottom: 10px !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 15px;
  text-align: left;
  letter-spacing: 0;
  word-wrap: break-word;
}

.buttonContainer {
  align-items: center;
  justify-content: right;
}

.vl {
  height: 20px;
  border-left: 3px solid rgb(206, 206, 206);
}
.inactiveBtn {
  background: #c9c8c8;
  border-radius: 3px;
}

.activeBtn {
  background: #5498d8;
  border-radius: 3px;
}
.hrRouterLinkTextStrong {
  font-size: 14px;
  font-weight: 800;
  color: #ebebeb !important;
}

.hrRouterLinkText {
  font-size: 14px;
  color: #585858 !important;
}
.privacyText {
  font-size: 15px;
  font-weight: 400;
  line-height: 10px;
  color: #0476d9;
  text-align: left;
  text-decoration: none;
  letter-spacing: 0;
}
</style>
